<template>
<!-- <div class="patentSearch contentBack "> -->
     <div class="enterprise-infoqy">
        <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="
    margin-top:13px;margin-left:14px;">
      <el-breadcrumb-item>企业管理 </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/Enterprisesearch' }" >企业查询 </el-breadcrumb-item>
       <el-breadcrumb-item >企业信息详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容区域 -->
    <div class="trdemark-main">
        <div class="trdemark-titlecom">
            {{ enterbasicDataDetails.ap }}
        </div>
        <!-- 基本信息 -->
        <div class="basic-infoqy">
             <div class="trdemark-line">
                <div class="basic-header">
                    <div></div>
               企业信息
            </div>
            </div>
           
               
                <ul class="basic-nameqy">
                    <li>企业名称：<span>{{ enterbasicDataDetails.ap }}</span></li>
                    <li>经营状态：<span>{{ enterbasicDataDetails.ls }}</span></li>
                    <li>法人代表：<span>{{ enterbasicDataDetails.frdb }}</span></li>
                    <li>注册资金（万元）：<span>{{ enterbasicDataDetails.zczb }}</span></li>
                  
                    
                </ul>
                <ul class="basic-nameqy">
                   
                    <li>注册日期：<span>{{ enterbasicDataDetails.clrq }}</span></li>
                    <li>社会信用代码：<span>{{ enterbasicDataDetails.xydm }}</span></li>
                      <li>企业地址：<span>{{ enterbasicDataDetails.apad }}</span></li>
                    
                </ul>
                <ul class="basic-nameqy">
                     <li>经营范围：<span>{{ enterbasicDataDetails.jyfw }}</span></li>
                </ul>
            
        </div>
        <!-- 专利信息 -->
        <div class="enterprise-main">
        <div class="basic-infoqy">
           <div class="trdemark-line">
                <div class="basic-header">
                    <div></div>
               专利信息
            </div>
            </div>
            <!-- <ul class="basic-nameqy ">
                <li class="aoolicant-name">专利分类：<span>全部（100）</span> <span>外观设计（80）</span><span>发明（10）</span><span>实用新型（10）</span></li>
                
            </ul>
            <ul class="basic-nameqy ">
               
                <li class="aoolicant-name">法律状态：<span>在审（100）</span> <span>有效（80）</span><span>无效（10）</span></li>
            </ul> -->
              <div class="zlChoose">
                    <span class="aoolicant-name">专利分类：</span>
                    <span
                      :class="{ turnOrange: zlTypeselect == '' }"
                      @click="zlselect1(0)"
                      >全部（{{ detailszlNum[0].total }}）</span
                    >
                    <span
                      :class="{ turnOrange: zlTypeselect == '3' }"
                      @click="zlselect1(1)"
                      >外观设计（{{ detailszlNum[0].waiguan }}）</span
                    >
                    <span
                      :class="{ turnOrange: zlTypeselect == '1' }"
                      @click="zlselect1(2)"
                      >发明（{{ detailszlNum[0].faming }}）</span
                    >
                    <span
                      :class="{ turnOrange: zlTypeselect == '2' }"
                      @click="zlselect1(3)"
                      >实用新型（{{ detailszlNum[0].shiyong }}）</span
                    >
                  </div>
                   <div class="zlChoose">
                    <span class="aoolicant-name">法律状态：</span>
                     <span
                      :class="{ turnOrange: zlLawselect == '' }"
                      @click="zlselect2(7)"
                      >全部（{{ detailszlNum[1].quanbu }}）</span
                    >
                    <span
                      :class="{ turnOrange: zlLawselect == '30' }"
                      @click="zlselect2(4)"
                      >在审（{{ detailszlNum[1].zaishen }}）</span
                    >
                    <span
                      :class="{ turnOrange: zlLawselect == '10' }"
                      @click="zlselect2(5)"
                      >有效（{{ detailszlNum[1].youxiao }}）</span
                    >
                    <span
                      :class="{ turnOrange: zlLawselect == '20' }"
                      @click="zlselect2(6)"
                      >无效（{{ detailszlNum[1].wuxiao }}）</span
                    >
                  </div>
                     <!-- 表格结果 -->
                  <div class="listTitle titleBold" style="margin-top: 12px">
                    全部（{{ totalzl }}）
                   
                   <div class="alrtbtn">
                    <el-button
                      @click="daochu1"
                      >导出Excel</el-button
                    >
                     </div>
                  </div>
                  <el-table
                    ref="multipleTable2"
                    :data="tablezldata"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange1"
                    border
                  >
                    <!-- 选择框 -->
                    <el-table-column type="selection" width="40" :resizable="false">
                    </el-table-column>

                    <!-- 申请/注册号 -->
                    <el-table-column label="申请/注册号" width="145" :resizable="false">
                      <template slot-scope="scope">
                        <!-- <div class="apStyle" @click="openzl(scope.row)">
                          {{ scope.row.sPatentnumber }}
                        </div> -->
                         <div  >
                          {{ scope.row.sPatentnumber }}
                        </div>
                      </template>
                    </el-table-column>
                    <!-- 专利名称 -->
                    <el-table-column
                      prop="sTitle"
                      label="专利名称"
                      show-overflow-tooltip
                       :resizable="false"
                    ></el-table-column>
                    <!-- 申请人 -->
                    <el-table-column
                      prop="sProposer1st"
                      label="申请人"
                      show-overflow-tooltip
                       :resizable="false"
                    >
                    </el-table-column>
                    <!-- 专利类型 -->
                    <el-table-column
                      prop="sPatenttype"
                      label="专利类型"
                      width="77"
                       :resizable="false"
                    >
                    </el-table-column>
                    <!-- 法律状态 -->
                    <el-table-column
                      prop="sLawmark"
                      label="法律状态"
                      width="77"
                       :resizable="false"
                    >
                    </el-table-column>
                    <!-- 申请日 -->
                    <el-table-column
                      prop="dtApplydate"
                      label="申请日"
                      width="94"
                       :resizable="false"
                    >
                    </el-table-column>
                    <!-- 公开日 -->
                    <el-table-column prop="dtPubdate" label="公开日" width="94"  :resizable="false">
                    </el-table-column>
                    <!-- 授权日  -->
                    <el-table-column
                      prop="dtAuthdate"
                      label="授权日"
                      width="94"
                       :resizable="false"
                    >
                    </el-table-column>
                  </el-table>
                    <div class="page-pagination">
                    <el-pagination
                      @size-change="handleSizeChange1"
                      @current-change="handleCurrentChange1"
                      :current-page.sync="currentPage1"
                      :page-sizes="[10, 15, 20]"
                      :page-size="10"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="totalzl"
                    >
                    </el-pagination>
                     <el-button size="mini" type="primary" style="margin-left:5px">确定</el-button>
                  </div>
        </div>
        <!-- 专利表格 -->
        
        </div>
        <!-- 商标信息 -->
    <div class="basic-infoqy no-border">
        <div class="trdemark-line">
                <div class="basic-header">
                    <div></div>
               商标信息
            </div>
            </div>
       <div class="zlChoose">
                    <span>法律状态：</span>
                    
                    <span
                      :class="{ turnOrange: sbLawselect == 1 }"
                      @click="sbselect(1)"
                      >在审（{{ detailssbNum.zaishen }}）</span
                    >
                    <span
                      :class="{ turnOrange: sbLawselect == 2 }"
                      @click="sbselect(2)"
                      >有效（{{ detailssbNum.youxiao }}）</span
                    >
                    <span
                      :class="{ turnOrange: sbLawselect == 3 }"
                      @click="sbselect(3)"
                      >无效（{{ detailssbNum.wuxiao }}）</span
                    >
                  </div>
                  <div class="listTitle titleBold" style="margin-top: 12px">
                    全部（{{ totalsb }}）
                   <div class="alrtbtn">
                    <el-button
                      @click="daochu2"
                      >导出Excel</el-button
                    >
                     </div>
                  </div>
                  <el-table
                    ref="multipleTable3"
                    :data="tablesbdata"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange2"
                    border
                  >
                    <!-- 选择框 -->
                    <el-table-column type="selection" width="40" :resizable="false">
                    </el-table-column>

                    <!-- 商标号 -->
                    <el-table-column prop="an" label="商标号" min-width="85" :resizable="false">
                      <template slot-scope="scope">
                        <!-- <div class="apStyle" @click="opensb(scope.row)">
                          {{ scope.row.an }}
                        </div> -->
                        <div >
                          {{ scope.row.an }}
                        </div>
                      </template>
                    </el-table-column>
                    <!-- 商标名称 -->
                    <el-table-column
                      prop="ti"
                      label="商标名称"
                      show-overflow-tooltip
                       :resizable="false"
                    ></el-table-column>
                    <!-- 申请人 -->
                    <el-table-column
                      prop="ap"
                      label="申请人"
                      show-overflow-tooltip
                      :resizable="false"
                      width="150"
                    >
                    </el-table-column>
                    <!-- 国际分类 -->
                    <el-table-column prop="ic" label="国际分类" min-width="94" :resizable="false">
                    </el-table-column>
                    <!-- 法律状态 -->
                    <el-table-column prop="ls" label="法律状态" width="77" :resizable="false">
                    </el-table-column>
                    <!-- 申请日 -->
                    <el-table-column prop="apd" label="申请日" width="94" :resizable="false">
                    </el-table-column>
                    <!-- 初审日 -->
                    <el-table-column prop="pd" label="初审日" width="94" :resizable="false">
                    </el-table-column>
                    <!-- 注册日  -->
                    <el-table-column prop="gd" label="注册日" width="94" :resizable="false">
                    </el-table-column>
                  </el-table>
                  <!-- 分页 -->
                  <div  class="page-pagination">
                    <el-pagination
                      @size-change="handleSizeChange2"
                      @current-change="handleCurrentChange2"
                      :current-page.sync="currentPage2"
                      :page-sizes="[10, 15, 20]"
                      :page-size="10"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="totalsb"
                    >
                    </el-pagination>
                     <el-button size="mini" type="primary" style="margin-left:5px">确定</el-button>
                  </div>
    </div>
    </div>
    </div>
<!-- </div> -->
   
</template>

<script>
import {mapState} from 'vuex'
export default {
    data(){
        return{
            detailszlNum: [
            { total: "", faming: "", waiguan: "", shiyong: "" },
            { quanbu:"",zaishen: "", youxiao: "", wuxiao: "" },
            ],
             detailssbNum: { zaishen: "", youxiao: "", wuxiao: "" },
            zlTypeselect: "",
            zlLawselect: "",
            totalzl:0,
            totalsb: 0,
            zlbasicDataDetails: {},
            sbbasicDataDetails: {},
            sbLawselect: "",
            tablezldata:[],
            tablesbdata: [],
            currentPage1: 1,
            currentPage2: 1,
             total: 0,
      pageSize: 10,
      pageSize1: 10,
      pageSize2: 10,
      pageNum: 1,
      pageNum1: 1,
      pageNum2: 1,
            multipleSelection1: [],
            multipleSelection2: [],

        }
    },
    computed: {
        ...mapState(['enterbasicDataDetails'])
    },
    mounted(){
        // console.log(this.enterbasicDataDetails)
    },
    created(){
        this.getzldetails()
        this.getsbdetails()
        this.zlList()
        this.sbList()
    },
    methods:{
                // 获取专利列表的方法
    zlList(law, type) {
      this.$get("/patent/apList", {
        token: localStorage.getItem("token"),
        apid: this.enterbasicDataDetails.apid,
        law: law,
        type: type,
        pageSize: this.pageSize1,
        pageNum: this.pageNum1,
      }).then((res) => {
        this.tablezldata = res.data.records;
        this.totalzl = res.data.total;
        this.tablezldata.forEach((ele) => {
          if (ele.sPatenttype == "1") {
            ele.sPatenttype = "发明";
          } else if (ele.sPatenttype == "2") {
            ele.sPatenttype = "实用新型";
          } else if (ele.sPatenttype == "3") {
            ele.sPatenttype = "外观设计";
          }
          if (ele.sLawmark == "30") {
            ele.sLawmark = "在审";
          } else if (ele.sLawmark == "20") {
            ele.sLawmark = "无效";
          } else if (ele.sLawmark == "10") {
            ele.sLawmark = "有效";
          }
          if (ele.dtApplydate !== null) {
            ele.dtApplydate = ele.dtApplydate.split(" ")[0];
          }
          if (ele.dtPubdate !== null) {
            ele.dtPubdate = ele.dtPubdate.split(" ")[0];
          }
          if (ele.dtAuthdate !== null) {
            ele.dtAuthdate = ele.dtAuthdate.split(" ")[0];
          }
        });
      });
    },
        // 筛选专利详情
    zlselect1(value) {
      this.currentPage1=1
      //专利分类
      if (value == 0) {
        this.zlTypeselect = "";
      } else if (value == 1) {
        this.zlTypeselect = "3";
      } else if (value == 2) {
        this.zlTypeselect = "1";
      } else if (value == 3) {
        this.zlTypeselect = "2";
      }
    },
        // 筛选商标详情
    sbselect(value) {
      if (this.sbLawselect == value) {
        this.sbLawselect = "";
      } else {
        this.sbLawselect = value;
        this.currentPage2=1
      }
    },
    zlselect2(value) {
      this.currentPage1=1
      //法律状态
      let id = value == 4 ? "30" : value == 5 ? "10" : "20";
      if (this.zlLawselect == id) {
        this.zlLawselect = "";
      } else {
        if (value == 4) {
          this.zlLawselect = "30";
        } else if (value == 5) {
          this.zlLawselect = "10";
        } else if (value == 6) {
          this.zlLawselect = "20";
        } else if (value == 7) {
          this.zlLawselect = "";
        }
      }
    },
          // 多选
 
    handleSelectionChange1(val) {
      this.multipleSelection1 = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    // 分页
    handleSizeChange(val) {
      this.reSearch = false;
      this.pageSize = val;
      if (this.isGjcx) {
        this.GJCXsubmit(this.pageNum, val, this.order, this.orderType);
      } else {
        this.getFirmMsg(
          this.paramslabel,
          this.pageNum,
          val,
          this.order,
          this.orderType
        );
      }
    },
    handleCurrentChange(val) {
      this.reSearch = false;
      this.currentPage = val;
      this.pageNum = val;
      if (this.isGjcx) {
        this.GJCXsubmit(val, this.pageSize, this.order, this.orderType);
      } else {
        this.getFirmMsg(
          this.paramslabel,
          val,
          this.pageSize,
          this.order,
          this.orderType
        );
      }
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.zlList(this.zlLawselect, this.zlTypeselect);
    },
    handleCurrentChange1(val) {
      this.pageNum1 = val;
      this.zlList(this.zlLawselect, this.zlTypeselect);
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.sbList();
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val;
      this.sbList();
    },

        // 获取商标列表
        sbList() {
      this.$get("/trademark/getTm", {
        token: localStorage.getItem("token"),
        apid: this.enterbasicDataDetails.apid,
        ls: this.sbLawselect,
        pageSize: this.pageSize2,
        pageNum: this.pageNum2,
      }).then((res) => {
        this.tablesbdata = res.data.records;
        this.tablesbdata.forEach((ele) => {
          if (ele.ls == "1") {
            ele.ls = "在审";
          } else if (ele.ls == "2") {
            ele.ls = "有效";
          } else if (ele.ls == "3") {
            ele.ls = "无效";
          }
          if (ele.apd !== null) {
            ele.apd = ele.apd.split(" ")[0];
          }
          if (ele.pd !== null) {
            ele.pd = ele.pd.split(" ")[0];
          }
          if (ele.gd !== null) {
            ele.gd = ele.gd.split(" ")[0];
          }
        });
        this.totalsb = res.data.total;
      });
    },
            // 获取专利/商标详情数量的方法
    getzldetails() {
      this.detailszlNum = [
        { total: "", faming: "", waiguan: "", shiyong: "" },
        { quanbu:"", zaishen: "", youxiao: "", wuxiao: "" },
      ];
      this.$get("/patent/count", {
        token: localStorage.getItem("token"),
        apid: this.enterbasicDataDetails.apid,
      }).then((res) => {
        let type = res.data.type;
        let law = res.data.law;
        for (let i = 0; i < type.length; i++) {
          if (type[i].name == "total") {
            this.detailszlNum[0].total = type[i].num;
          } else if (type[i].name == "1") {
            this.detailszlNum[0].faming = type[i].num;
          } else if (type[i].name == "2") {
            this.detailszlNum[0].shiyong = type[i].num;
          } else if (type[i].name == "3") {
            this.detailszlNum[0].waiguan = type[i].num;
          }
        }
        for (let i = 0; i < law.length; i++) {
          if (law[i].name == "total") {
            this.detailszlNum[1].quanbu = law[i].num;
          }else if(law[i].name == "10") {
            this.detailszlNum[1].youxiao = law[i].num;
          } else if (law[i].name == "20") {
            this.detailszlNum[1].wuxiao = law[i].num;
          } else if (law[i].name == "30") {
            this.detailszlNum[1].zaishen = law[i].num;
          }
        }
      });
    },
        getsbdetails() {
      this.$get("/applicant/info", {
        token: localStorage.getItem("token"),
        rid: this.enterbasicDataDetails.rid,
      }).then((res) => {
        let lsid = res.data.tm.ls;
        lsid.forEach((ele) => {
          if (ele.name == "1") {
            this.detailssbNum.zaishen = ele.num;
            // '在审'
          } else if (ele.name == "2") {
            this.detailssbNum.youxiao = ele.num;
            // '有效'
          } else if (ele.name == "3") {
            this.detailssbNum.wuxiao = ele.num;
            // '无效'
          }
        });
      });
    },
      daochu1() {
      if (this.multipleSelection1.length > 0) {
        let a = [];
        this.multipleSelection1.forEach((ele) => {
          // console.log('ele',ele)
          a.push(ele.sPatentnumber);
        });
        let ans = a.join(";");
        let aLink = document.createElement("a");
        aLink.href =
          this.$url +
          "/patent/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.enterbasicDataDetails.apid +
          "&ans=" +
          ans;
        aLink.click();
      } else {
        let aLink5 = document.createElement("a");
        aLink5.href =
          this.$url +
          "/patent/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.enterbasicDataDetails.apid +
          "&law=" +
          this.zlLawselect +
          "&type=" +
          this.zlTypeselect;
        aLink5.click();
      }
    },
    daochu2() {
      if (this.multipleSelection2.length > 0) {
        let b = [];
        this.multipleSelection2.forEach((ele) => {
          b.push(ele.rid);
        });
        let rids = b.join(";");
        let aLink6 = document.createElement("a");
        aLink6.href =
          this.$url +
          "/trademark/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.enterbasicDataDetails.apid +
          "&rids=" +
          rids +
          "&ls=" +
          this.sbLawselect+"&uid="+localStorage.getItem('uid');
        aLink6.click();
      } else {
        let aLink7 = document.createElement("a");
        aLink7.href =
          this.$url +
          "/trademark/export?token=" +
          localStorage.getItem("token") +
          "&apid=" +
          this.enterbasicDataDetails.apid +
          "&ls=" +
          this.sbLawselect+"&uid="+localStorage.getItem('uid');
        aLink7.click();
      }
    },
  
    },
    watch: {
    zlTypeselect() {

      this.pageNum1 = 1;
      this.pageSize1 = 10;
    
        this.zlList(this.zlLawselect, this.zlTypeselect);
      
    },
    zlLawselect() {
      this.pageNum1 = 1;
      this.pageSize1 = 10;
      
      this.zlList(this.zlLawselect, this.zlTypeselect);
      
    },
    sbLawselect() {
      this.pageNum2 = 1;
      this.pageSize2 = 10;
      
      this.sbList();
      
    },
  },
    
}
</script>
<style >
.enterprise-infoqy {
    width: 98%;
    height: 98%;
    position: absolute;
    bottom: 0;
    background: #fff;
    left: 20px;
    overflow-y: auto;
}

.basic-nameqy {
    width: 90%;
    display: flex;
    justify-content: space-between;
    list-style: none;
    overflow: auto;
    margin-top: 15px;
}
.basic-nameqy > li {
    margin-bottom: 12px;
    font-size: 14px;
    color: #6b6b6b;
}
.basic-nameqy >li span {
    color: #000;
    font-size: 14px;
    line-height: 22px;
}
.basic-nameqy .aoolicant-name > span {
    color: #1471d5;
    margin-left: 16px;
}

.trdemark-line {
    width: 80%;
}
.basic-header {
        display: flex;
        height: 30px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 700;
        color: #1773d5;
        line-height: 22px;
        letter-spacing: 0.5px;
    }
.basic-header > div {
    width: 4px;
    height: 16px;
    background: #1b75d5;
    border-radius: 2px;
    margin: 4px 27px 0px 0px;
    }
.trdemark-main {
    overflow: hidden;
    min-height: 500px;
        margin-top: 7px;
    margin-left: 14px;
    width: 98%;
    min-height: 600px;
    background: #fff;
}
.trdemark-titlecom {
    width: 99%;
    margin: 0 auto;
    line-height: 40px;
    background: #e7f3ff;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #1773d5;
    letter-spacing: 0.5px;
}
.basic-infoqy {
    width: 98%;
    margin: 14px;
    border-bottom: 1px solid #dddddd;
}
   .no-border {
    border: none !important;
}
.basic-list {
    margin-left: 40px;
    display: flex;
    justify-content: space-around;
    padding: 15px 20px;
    }
.mark-img {
    width: 138px;
    height: 130px;
    background-color: pink;
    }
img {
    width: 100%;
    height: 100%;
    }

</style>
